import { Spin } from 'antd';
import { CLIENT_ID } from 'constants/AuthConstant';
import { Observer } from 'mobx-react';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useMainStore } from 'store/mobXStores/mainStore';

const AutoLogin = () => {
	const mainStore = useMainStore();

	const { autoLoginStore } = mainStore;

	const query = new URLSearchParams(window.location.search);
	const clientId = query.get('clientId');
	sessionStorage.setItem(CLIENT_ID, clientId);

	useEffect(() => {
		const { autoLogin } = autoLoginStore;
		autoLogin(window.location.search);
	}, []);

	return (
		<Observer>
			{() => {
				const { autoLoginSuccess, autoLoginInProgress } = autoLoginStore;

				if (!autoLoginInProgress && autoLoginSuccess) {
					return <Navigate to="/" />;
				}

				return (
					<div className="bg-gray-lighter">
						<div className="container">
							<div className="d-flex justify-content-center align-items-center vh-100">
								<Spin size="large" />
							</div>
						</div>
					</div>
				);
			}}
		</Observer>
	);
};

export default AutoLogin;
